import { createFileRoute } from '@tanstack/react-router';
import { TermsPage } from '../../pages/TermsPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/terms')({
  head: () =>
    staticPageHead({
      path: '/terms',
      title: 'Terms of Service - AnyAPI',
      description:
        'The terms governing use of the AnyAPI gateway: accounts, the prepaid USD wallet, pricing, refunds, acceptable use, and liability.',
      crumb: 'Terms of Service',
    }),
  component: TermsPage,
});
